export const stripePublishableTestKey = 'pk_test_bHvaIan6p9c0QrwIbqRQorss'
export const stripePublishableLiveKey = 'pk_live_S2Cdyp0reoeYcSjmNgGgJYKg'